import { render } from "./ReportBuilderTab.vue?vue&type=template&id=fc73ea3c&ts=true"
import script from "./ReportBuilderTab.vue?vue&type=script&lang=ts"
export * from "./ReportBuilderTab.vue?vue&type=script&lang=ts"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__